import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';
import { Box, Button, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

type ImportCsvPromptDialogProps = {
  open: boolean;
  onClose: () => void;
  onImport: () => void;
};

export const ImportCsvPromptDialog = ({
  open,
  onClose,
  onImport,
}: ImportCsvPromptDialogProps) => {
  const { t } = useTranslation(['modelPortfolios', 'shared']);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      data-testid='import-csv-prompt-dialog'
    >
      <DialogTitle onClose={onClose}>
        {t('modelPortfolios:importCsv.title')}
      </DialogTitle>
      <DialogContent>
        <Typography
          variant='bodyLarge'
          sx={{
            color: 'text.secondary',
            fontSize: '16px',
          }}
        >
          {t('modelPortfolios:importCsv.description')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            gap: 1,
            mt: 3,
          }}
        >
          <Button
            onClick={onClose}
            variant='contained'
            data-testid='import-csv-prompt-later-button'
            color='secondary'
          >
            {t('shared:later')}
          </Button>
          <Button
            onClick={() => {
              onClose();
              onImport();
            }}
            variant='contained'
            color='primary'
            data-testid='import-csv-prompt-import-button'
          >
            {t('modelPortfolios:importCsv.import')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImportCsvPromptDialog;
